import OpenAI from "openai";

export default class ImageGenerator {
  constructor(element) {
    this.element = element;
    this.openai = new OpenAI({ apiKey: process.env.API_KEY_OPENAI, dangerouslyAllowBrowser: true });

    this.input = document.querySelector("#input-image-generator");
    this.submit = document.querySelector("#submit-image-generator");
    this.swiper = document.querySelector("#swiper-image-generator");
    this.aiLoading = document.querySelector(".ai-loading");

    this.init();
  }

  init() {
    this.fetchStoredImages();
    console.log("Image Generator");

    this.submit.addEventListener("click", () => this.main(this.input.value));
  }

  async main(prompt) {
    console.log(this.isReady);
    if (this.isReady) {
      console.log("Génération de l'image");
      this.aiLoading.classList.remove("d-none");
      this.isReady = false;
      try {
        const response = await this.openai.images.generate({
          model: "dall-e-3",
          prompt: prompt,
          n: 1,
          size: "1024x1024"
        });

        try {
          const storeResponse = await fetch("/dashboard/models/store_images.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ url: response.data[0].url })
          });

          console.log(storeResponse);
          console.log("Success:", await storeResponse.json());
          await this.fetchStoredImages();
        } catch (error) {
          console.error("Error:", error);
        }
      } catch (error) {
        if (error.response) {
          console.log(error.response.status);
          console.log(error.response.data);
        } else {
          console.log(error.message);
        }
      }
    }
  }

  async fetchStoredImages() {
    try {
      const response = await fetch("/dashboard/controllers/get_images.php");
      const data = await response.json();
      const urls = data.map(item => item.image);

      const swiperSlides = this.swiper.querySelectorAll(".swiper-slide");
      let countSlide = 0;
      swiperSlides.forEach(slide => {
        if (urls[countSlide]) {
          slide.querySelector("img").setAttribute("src", `${urls[countSlide]}`);
        }
        countSlide++;
      });
    } catch (error) {
      console.error("Error:", error);
    }
    this.aiLoading.classList.add("d-none");
    this.isReady = true;
  }
}
